import React from "react";
import { Quote } from "lucide-react";
import { testimonial } from "../mock";

export default function Testimonial() {
  return (
    <section className="py-24 lg:py-32 bg-[var(--ink-2)] border-y border-[var(--line)] relative overflow-hidden">
      <div className="absolute -top-20 left-1/2 -translate-x-1/2 w-[40rem] h-[40rem] rounded-full bg-[var(--gold)]/[0.06] blur-[130px] pointer-events-none" />
      <div className="relative max-w-4xl mx-auto px-6 lg:px-10 text-center reveal">
        <p className="eyebrow">{testimonial.eyebrow}</p>
        <Quote size={34} className="mx-auto mt-8 text-[var(--gold)]/45" strokeWidth={1.25} />
        <blockquote className="mt-6 text-xl sm:text-[1.7rem] font-light leading-[1.6] tracking-[-0.005em] text-[var(--ivory)]/85">
          “{testimonial.text}”
        </blockquote>

        <div className="mt-12 flex flex-col items-center gap-4">
          <img
            src={testimonial.avatar}
            alt={testimonial.author}
            className="w-16 h-16 rounded-full object-cover border border-[var(--gold)]/40"
          />
          <div>
            <div className="font-serif-display text-lg font-semibold tracking-tight">{testimonial.author}</div>
            <div className="text-sm text-[var(--gold)] mt-1">{testimonial.meta}</div>
            <div className="text-sm text-[var(--muted)] mt-1">{testimonial.roles}</div>
          </div>
        </div>
      </div>
    </section>
  );
}
